import { jobsStore } from './jobs-store';

export const selectJob = jobsStore.select;
export * from './use-jobs-state';
